const ITEMS = [
  "Global Health NGOs",
  "Wearable Innovators",
  "Patent Protected",
  "Smartwatch Integration",
  "Refillable Reservoir",
  "Breathing Valve",
  "On-Demand Protection",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="brand-marquee"
      className="relative overflow-hidden border-y border-zinc-800 bg-[#0a0a0a] py-6"
    >
      <div className="flex w-max animate-marquee">
        {row.map((item, i) => (
          <div key={`${item}-${i}`} className="flex items-center">
            <span className="font-mono text-sm tracking-[0.15em] uppercase text-zinc-500 whitespace-nowrap px-16">
              {item}
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#00e5ff]/60" />
          </div>
        ))}
      </div>
    </div>
  );
}
